<template>
  <div>
    <l-geo-json
      :geojson="geojsonData.geojson"
      :options="geojsonOptions"
      ref="geolayer"
      @click="mapOnClick()"
    />
    <slot
      :currentItem="currentItem"
      :unit="value.metric"
      :min="min"
      :max="max"
    />
  </div>
</template>
<script>
import L from 'leaflet'
import { LGeoJson } from 'vue2-leaflet'
import { getMin, getMax, getColor, validNumber } from '@/core/helpers/util.js'

function onclick({ target }) {
  console.log(target)
}

function mouseover({ target }) {
  // console.log('onMouseOver')
  target.setStyle({
    weight: this.currentStrokeWidth,
    color: `#${this.currentStrokeColor}`,
    dashArray: '',
  })

  if (!L.Browser.ie && !L.Browser.opera) {
    target.bringToFront()
  }

  let geojsonItem = target.feature.properties
  let tempGeojsonIdKey = geojsonItem[this.geojsonIdKey]

  let item = this.geojsonData.data.find(
    (x) => x[this.idKey] == this.newGeojsonIdKey(tempGeojsonIdKey)
  )
  if (!item) {
    this.currentItem = { name: '', value: 0 }
    return
  }

  let label
  label = `<span class="text-primary font-weight-bolder h2">${item['value']}%</span>`
  label += `<span class="text-dark-50 font-size-lg pl-1">(laporan dari ${item['count_report']} sekolah)</span>`
  let tempItem = { name: item[this.titleKey], value: label }
  this.currentItem = tempItem
}

function mouseout({ target }) {
  target.setStyle({
    weight: this.strokeWidth,
    color: `#${this.strokeColor}`,
    dashArray: '',
  })
  this.currentItem = { name: '', value: 0 }
}

export default {
  props: {
    geojson: Object,
    data: Array,
    center: Array,
    colorScale: Array,
    titleKey: String,
    idKey: String,
    value: Object,
    extraValues: Array,
    geojsonIdKey: String,
    mapStyle: Object,
    zoom: Number,
    mapOptions: Object,
    strokeColor: { type: String, default: 'fff' },
    currentStrokeColor: { type: String, default: '666' },
    strokeWidth: { type: Number, default: 2 },
    currentStrokeWidth: { type: Number, default: 5 },
  },
  mounted() {
    if (this.$parent._isMounted) {
      this.deferredMountedTo(this.$parent.mapObject)
    }

    this.$nextTick(() => {
      this.map = this.$refs.geolayer.mapObject // work as expected
    })
  },
  data() {
    return {
      map: null,
      currentItem: { name: '', value: 0 },
      geojsonOptions: {
        style: (feature) => {
          // return
          let itemGeoJSONID = feature.properties[this.geojsonIdKey]

          // console.log(this.geojsonIdKey)
          const { data } = this.geojsonData
          let item = data.find(
            (x) => x[this.idKey] == this.newGeojsonIdKey(itemGeoJSONID)
          )
          if (!item) {
            return {
              color: 'white',
              weight: this.strokeWidth,
              fillOpacity: 0.6,
              fillColor: '#eee',
            }
          }
          let valueParam = Number(item[this.value.key])
          if (!validNumber(valueParam)) {
            return {
              color: 'white',
              weight: this.strokeWidth,
            }
          }
          const { min, max } = this

          return {
            weight: this.strokeWidth,
            opacity: 1,
            color: `#${this.strokeColor}`,
            dashArray: '3',
            fillOpacity: 0.7,
            fillColor: getColor(valueParam, this.colorScale, min, max),
          }
        },
        onEachFeature: (feature, layer) => {
          // return
          layer.on({
            mouseover: mouseover.bind(this),
            mouseout: mouseout.bind(this),
            click: onclick.bind(this),
          })
        },
      },
    }
  },
  computed: {
    min() {
      return getMin(this.geojsonData.data, this.value.key)
    },
    max() {
      return getMax(this.geojsonData.data, this.value.key)
    },
    geojsonData() {
      return { geojson: { ...this.geojson }, data: this.data }
    },
  },
  components: {
    LGeoJson,
  },
  methods: {
    deferredMountedTo(parent) {
      this.parent = parent
      for (var i = 0; i < this.$children.length; i++) {
        if (typeof this.$children[i].deferredMountedTo === 'function') {
          this.$children[i].deferredMountedTo(parent)
        }
      }
    },
    mapOnClick: function () {
      this.$parent.$emit('map-on-click')
    },
    newGeojsonIdKey(param) {
      if (param !== undefined) {
        if (param.includes('ID')) {
          return param.substring(2)
        }
      }

      return param
    },
  },
}
</script>
